import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Optional, EventEmitter, Component, Injector, Input, Output, NgModule } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { SearchParams } from '@mt-ng2/common-classes';
import { format } from '@mt-ng2/format-functions';
import { SortDirection, EntityListConfig, EntityListColumn, EntityListModule } from '@mt-ng2/entity-list-module';
import { EntityComponentsAddressesModuleConfigToken } from '@mt-ng2/entity-components-addresses-config';
import { debounceTime } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { MtAlertsModule } from '@mt-ng2/alerts-module';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@mt-ng2/dynamic-form';
import * as ɵngcc4 from '@mt-ng2/alerts-module';
import * as ɵngcc5 from '@mt-ng2/entity-list-module';
import * as ɵngcc6 from '@angular/router';

function CommonAddressesComponent_div_1_ul_5_li_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    ɵngcc0.ɵɵstyleProp("margin-top", 3, "px");
} }
function CommonAddressesComponent_div_1_ul_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesComponent_div_1_ul_5_li_2_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const address_r7 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.selectedAddress = address_r7; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, CommonAddressesComponent_div_1_ul_5_li_2_i_2_Template, 1, 2, "i", 13);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const address_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\n                    ", ctx_r6.getIndividualAddressTitle(address_r7.Address), "\n                    ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showIsPrimary && address_r7.IsPrimary);
} }
function CommonAddressesComponent_div_1_ul_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 10);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵtemplate(2, CommonAddressesComponent_div_1_ul_5_li_2_Template, 4, 2, "li", 11);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.addressContainerArray);
} }
function CommonAddressesComponent_div_1_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("No ", ctx_r3.getComponentName(), "");
} }
function CommonAddressesComponent_div_1_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r4._max, " of ", ctx_r4._total, "");
} }
function CommonAddressesComponent_div_1_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 16);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesComponent_div_1_div_22_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.seeAll(); });
    ɵngcc0.ɵɵtext(3, "see all\n                    ");
    ɵngcc0.ɵɵelementStart(4, "span", 17);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5._total);
} }
function CommonAddressesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵtemplate(5, CommonAddressesComponent_div_1_ul_5_Template, 4, 1, "ul", 3);
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵtemplate(7, CommonAddressesComponent_div_1_i_7_Template, 2, 1, "i", 4);
    ɵngcc0.ɵɵtext(8, "\n            ");
    ɵngcc0.ɵɵelementStart(9, "div", 5);
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵelementStart(11, "button", 6);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesComponent_div_1_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.addAddress(); });
    ɵngcc0.ɵɵtext(12, "\n                    ");
    ɵngcc0.ɵɵelement(13, "span", 7);
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementStart(17, "div", 8);
    ɵngcc0.ɵɵtext(18, "\n                ");
    ɵngcc0.ɵɵtemplate(19, CommonAddressesComponent_div_1_span_19_Template, 2, 2, "span", 4);
    ɵngcc0.ɵɵtext(20, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(21, "\n            ");
    ɵngcc0.ɵɵtemplate(22, CommonAddressesComponent_div_1_div_22_Template, 8, 1, "div", 9);
    ɵngcc0.ɵɵtext(23, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getComponentName());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.addressContainerArray.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addressContainerArray.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.hideAdd());
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTotal());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTotal());
} }
function CommonAddressesComponent_div_3_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 24);
    ɵngcc0.ɵɵlistener("mtConfirm", function CommonAddressesComponent_div_3_button_15_Template_button_mtConfirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.delete(); });
    ɵngcc0.ɵɵtext(1, "Delete");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonAddressesComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "form", 19);
    ɵngcc0.ɵɵlistener("ngSubmit", function CommonAddressesComponent_div_3_Template_form_ngSubmit_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.save(); });
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelement(7, "mt-address", 20);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementStart(9, "button", 21);
    ɵngcc0.ɵɵtext(10, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "button", 22);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesComponent_div_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.selectedAddress = null; });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵtemplate(15, CommonAddressesComponent_div_3_button_15_Template, 2, 0, "button", 23);
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                ", ctx_r1.selectedAddress.AddressId > 0 ? "Edit " + ctx_r1.getComponentName() : "Add " + ctx_r1.getComponentName(), "\n            ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.addressForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("addressContainer", ctx_r1.selectedAddress)("parentForm", ctx_r1.addressForm)("showIsPrimary", ctx_r1.showIsPrimary)("allowInternationalAddresses", ctx_r1._allowInternationalAddresses);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showDelete);
} }
function CommonAddressesListComponent_div_1_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesListComponent_div_1_div_30_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.addAddress(); });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 12);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "span", 13);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function () { return ["../"]; };
function CommonAddressesListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "input", 3);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵelementStart(8, "span", 4);
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵelementStart(10, "button", 5);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesListComponent_div_1_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clearSearch(); });
    ɵngcc0.ɵɵtext(11, "\n                            ");
    ɵngcc0.ɵɵelement(12, "i", 6);
    ɵngcc0.ɵɵtext(13, "\n                            ");
    ɵngcc0.ɵɵelement(14, "i", 7);
    ɵngcc0.ɵɵtext(15, "\n                            ");
    ɵngcc0.ɵɵelement(16, "i", 6);
    ɵngcc0.ɵɵtext(17, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                ");
    ɵngcc0.ɵɵelement(21, "br");
    ɵngcc0.ɵɵtext(22, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(23, "\n            ");
    ɵngcc0.ɵɵelementStart(24, "entity-list", 8);
    ɵngcc0.ɵɵlistener("currentPageChange", function CommonAddressesListComponent_div_1_Template_entity_list_currentPageChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.currentPage = $event; })("onPageChanged", function CommonAddressesListComponent_div_1_Template_entity_list_onPageChanged_24_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.getAddresses(); })("onItemSelected", function CommonAddressesListComponent_div_1_Template_entity_list_onItemSelected_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectAddress($event); })("onItemDeleted", function CommonAddressesListComponent_div_1_Template_entity_list_onItemDeleted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.deleteAddress($event); })("onColumnSorted", function CommonAddressesListComponent_div_1_Template_entity_list_onColumnSorted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.columnSorted($event); });
    ɵngcc0.ɵɵtext(25, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(26, "\n            ");
    ɵngcc0.ɵɵelementStart(27, "a", 9);
    ɵngcc0.ɵɵtext(28, "Back");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(29, "\n            ");
    ɵngcc0.ɵɵtemplate(30, CommonAddressesListComponent_div_1_div_30_Template, 7, 0, "div", 10);
    ɵngcc0.ɵɵtext(31, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.searchControl);
    ɵngcc0.ɵɵadvance(18);
    ɵngcc0.ɵɵproperty("entities", ctx_r0.addresses)("itemsPerPage", ctx_r0.itemsPerPage)("total", ctx_r0.total)("currentPage", ctx_r0.currentPage)("entityListConfig", ctx_r0.entityListConfig);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(8, _c0));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEdit);
} }
function CommonAddressesListComponent_div_3_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("mtConfirm", function CommonAddressesListComponent_div_3_button_15_Template_button_mtConfirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.delete(); });
    ɵngcc0.ɵɵtext(1, "\n                    Delete\n                ");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonAddressesListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n            ");
    ɵngcc0.ɵɵelementStart(5, "form", 15);
    ɵngcc0.ɵɵlistener("ngSubmit", function CommonAddressesListComponent_div_3_Template_form_ngSubmit_5_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.save(); });
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelement(7, "mt-address", 16);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵelementStart(9, "button", 17);
    ɵngcc0.ɵɵtext(10, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "button", 18);
    ɵngcc0.ɵɵlistener("click", function CommonAddressesListComponent_div_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.cancel(); });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n                ");
    ɵngcc0.ɵɵtemplate(15, CommonAddressesListComponent_div_3_button_15_Template, 2, 0, "button", 19);
    ɵngcc0.ɵɵtext(16, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("\n                ", ctx_r1.selectedAddress.AddressId > 0 ? "Edit " + ctx_r1.getComponentName() : "Add " + ctx_r1.getComponentName(), "\n            ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.addressForm);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("addressContainer", ctx_r1.selectedAddress)("parentForm", ctx_r1.addressForm)("allowInternationalAddresses", ctx_r1.allowInternationalAddresses);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedAddress.AddressId > 0);
} }
const defaultModuleConfig = {
    disableSort: false,
    max: 3,
};
class EntityComponentsAddressesModuleConfig {
    constructor(config) {
        Object.assign(this, defaultModuleConfig, config);
    }
}
EntityComponentsAddressesModuleConfig.ɵfac = function EntityComponentsAddressesModuleConfig_Factory(t) { return new (t || EntityComponentsAddressesModuleConfig)(ɵngcc0.ɵɵinject(EntityComponentsAddressesModuleConfigToken, 8)); };
EntityComponentsAddressesModuleConfig.ɵprov = ɵɵdefineInjectable({ factory: function EntityComponentsAddressesModuleConfig_Factory() { return new EntityComponentsAddressesModuleConfig(ɵɵinject(EntityComponentsAddressesModuleConfigToken, 8)); }, token: EntityComponentsAddressesModuleConfig, providedIn: "root" });
EntityComponentsAddressesModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [EntityComponentsAddressesModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsAddressesModuleConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EntityComponentsAddressesModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class AddressContainer {
    static getNew() {
        return {
            Address: {
                Address1: '',
                Address2: '',
                City: '',
                CountryCode: 'US',
                Id: 0,
                Province: '',
                StateCode: '',
                Zip: '',
            },
            AddressId: 0,
            IsPrimary: false,
        };
    }
}

class CommonAddressesComponent {
    constructor(injector) {
        this.injector = injector;
        this._addresses = [];
        this.addressesPassedIn = false;
        this.showIsPrimary = true;
        this._showDelete = true;
        this.onSave = new EventEmitter();
        this.onDelete = new EventEmitter();
        this._selectedAddress = null;
        this.states = [[]];
        this.route = injector.get(ActivatedRoute);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
        this.config = injector.get(EntityComponentsAddressesModuleConfig);
        this._max = this.config.max;
    }
    get addressContainerArray() {
        return this._addresses;
    }
    set addressContainerArray(value) {
        this.addressesPassedIn = true;
        this._addresses = value;
        this.selectedAddress = null;
    }
    set address(value) {
        this.addressesPassedIn = true;
        this._addresses = value ? [{ AddressId: value.Id, Address: value, IsPrimary: true }] : [];
        this.selectedAddress = null;
        this.max = 1;
        this.useMaxAsLimit = true;
    }
    set total(value) {
        this._total = value;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    set canAdd(value) {
        this._canAdd = value;
    }
    set seeAllUrl(value) {
        this._seeAllUrl = value;
    }
    set max(value) {
        if (value <= 1) {
            this.showIsPrimary = false;
        }
        this._max = value;
    }
    set allowInternationalAddresses(value) {
        this._allowInternationalAddresses = value;
    }
    set entityName(value) {
        this._entityName = value;
    }
    set showDelete(value) {
        this._showDelete = value;
    }
    get showDelete() {
        return this._showDelete && this.selectedAddress.AddressId > 0;
    }
    set useMaxAsLimit(value) {
        this._useMaxAsLimit = value;
    }
    get selectedAddress() {
        return this._selectedAddress;
    }
    set selectedAddress(value) {
        if (value === null) {
            this.addressForm = new FormGroup({});
        }
        this._selectedAddress = value;
    }
    get isEditing() {
        return this.selectedAddress && this._canEdit;
    }
    ngOnInit() {
        this.addressForm = new FormGroup({});
        this.setVariables();
        this.getAddresses();
    }
    /**
     * Assigns local variables to defaults or config properties.
     */
    setVariables() {
        var _a, _b;
        const config = this.route.parent.snapshot.data;
        if (config === null || config === void 0 ? void 0 : config.entityIdParam) {
            this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        }
        const service = this.service || (config === null || config === void 0 ? void 0 : config.service) || null;
        if (service) {
            if (typeof service === 'function') {
                this.service = this.injector.get(service);
            }
        }
        if (this._canEdit === undefined) {
            this._canEdit = (config === null || config === void 0 ? void 0 : config.claimType) ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        if (this._canAdd === undefined) {
            this._canAdd = this._canEdit;
        }
        if (this._allowInternationalAddresses === undefined) {
            this._allowInternationalAddresses = (_a = config === null || config === void 0 ? void 0 : config.allowInternationalAddresses) !== null && _a !== void 0 ? _a : false;
        }
        if (this._seeAllUrl === undefined) {
            this._seeAllUrl = (_b = config === null || config === void 0 ? void 0 : config.addressesPath) !== null && _b !== void 0 ? _b : 'addresses';
        }
        if (this._entityName === undefined) {
            this._entityName = (config && config.adressesEntityName) || null;
        }
    }
    getAddresses() {
        if (!this.addressesPassedIn && this.hasService()) {
            const searchparamProperties = {
                order: 'IsPrimary',
                orderDirection: SortDirection.Desc,
                query: '',
                take: this._max,
            };
            const searchparams = new SearchParams(searchparamProperties);
            this.service.getAddresses(this.parentId, searchparams).subscribe((response) => {
                this._addresses = response.body;
                this._total = +response.headers.get('X-List-Count');
            });
        }
    }
    getComponentName() {
        if (this._entityName) {
            return this._entityName;
        }
        if (this._max === 1 && this._useMaxAsLimit) {
            return 'Address';
        }
        return 'Addresses';
    }
    showTotal() {
        return this._total && this._total > this._max;
    }
    hideAdd() {
        return !this._canAdd || (this._useMaxAsLimit && this.addressContainerArray.length >= this._max);
    }
    hasService() {
        return this.service && this.parentId && this.parentId > 0;
    }
    seeAll() {
        this.router.navigate([`${this._seeAllUrl}`], {
            relativeTo: this.route,
        });
    }
    addAddress() {
        if (!this._canAdd) {
            return;
        }
        let newAddress = AddressContainer.getNew();
        if (!this._addresses || this._addresses.length === 0) {
            newAddress.IsPrimary = true;
        }
        this.selectedAddress = newAddress;
    }
    getIndividualAddressTitle(address) {
        return format.address(address);
    }
    save() {
        if (this.addressForm.valid) {
            if (this.addressesPassedIn) {
                this.onSave.emit(this.addressForm.value);
                this.selectedAddress = null;
            }
            else {
                this.saveAddress(this.addressForm);
            }
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(this.addressForm);
        }
    }
    saveAddress(addressForm) {
        const address = Object.assign({}, this._selectedAddress);
        address.AddressId = addressForm.value.Id;
        address.Address = {
            Address1: addressForm.value.Address1,
            Address2: addressForm.value.Address2,
            City: addressForm.value.City,
            CountryCode: addressForm.value.CountryCode,
            Id: addressForm.value.Id,
            Province: addressForm.value.Province,
            StateCode: addressForm.value.StateCode,
            Zip: addressForm.value.Zip,
        };
        address.IsPrimary = addressForm.value.IsPrimary;
        this.service.saveAddress(this.parentId, address).subscribe((success) => {
            this.notificationsService.success('Address Saved Successfully');
            if (this.selectedAddress.AddressId === 0) {
                this.selectedAddress.AddressId = success;
            }
            this.onSave.emit(this.selectedAddress);
            this.selectedAddress = null;
            this.getAddresses();
        }, () => this.notificationsService.error('Save Failed'));
    }
    cancel() {
        this.selectedAddress = null;
    }
    delete() {
        if (this.addressesPassedIn) {
            this.onDelete.emit(this.addressForm.value);
            this.selectedAddress = null;
        }
        else {
            this.deleteAddress(this.addressForm);
        }
    }
    deleteAddress(addressForm) {
        this.service.deleteAddress(this.parentId, addressForm.value.Id).subscribe(() => {
            this.notificationsService.success('Address Deleted');
            this.onDelete.emit(this.selectedAddress);
            this.selectedAddress = null;
            this.getAddresses();
        }, () => this.notificationsService.error('Delete Failed'));
    }
}
CommonAddressesComponent.ɵfac = function CommonAddressesComponent_Factory(t) { return new (t || CommonAddressesComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonAddressesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonAddressesComponent, selectors: [["app-common-addresses"]], inputs: { addressContainerArray: "addressContainerArray", address: "address", max: "max", useMaxAsLimit: "useMaxAsLimit", total: "total", canEdit: "canEdit", canAdd: "canAdd", seeAllUrl: "seeAllUrl", allowInternationalAddresses: "allowInternationalAddresses", entityName: "entityName", showDelete: "showDelete", service: "service" }, outputs: { onSave: "onSave", onDelete: "onDelete" }, decls: 5, vars: 2, consts: [["class", "miles-card padded", 4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "miles-card", "padded"], ["class", "list-group", 4, "ngIf"], [4, "ngIf"], [1, "fab-wrap", 3, "hidden"], ["type", "button", 1, "btn", "btn-primary", "btn-fab-md", "btn-fab-center", 3, "click"], [1, "fa", "fa-plus"], [1, "pull-right", "max-of-total"], ["class", "show-on-hover", 4, "ngIf"], [1, "list-group"], ["class", "list-group-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "list-group-item", 3, "click"], ["class", "fa fa-fw fa-star pull-right", "title", "Primary Address", 3, "marginTop", 4, "ngIf"], ["title", "Primary Address", 1, "fa", "fa-fw", "fa-star", "pull-right"], [1, "show-on-hover"], [1, "btn", "btn-primary", "btn-flat", "see-all", 3, "click"], [1, "badge"], [1, "miles-form", "padded"], [3, "formGroup", "ngSubmit"], [3, "addressContainer", "parentForm", "showIsPrimary", "allowInternationalAddresses"], ["type", "submit", 1, "btn", "btn-flat", "btn-success"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], ["type", "button", "class", "btn btn-flat btn-danger pull-right", 3, "mtConfirm", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-danger", "pull-right", 3, "mtConfirm"]], template: function CommonAddressesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonAddressesComponent_div_1_Template, 24, 6, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CommonAddressesComponent_div_3_Template, 18, 7, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditing);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditing);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.ɵangular_packages_forms_forms_y, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.MtAddressComponent, ɵngcc4.MtConfirmDirective], encapsulation: 2 });
CommonAddressesComponent.ctorParameters = () => [
    { type: Injector }
];
CommonAddressesComponent.propDecorators = {
    addressContainerArray: [{ type: Input, args: ['addressContainerArray',] }],
    service: [{ type: Input, args: ['service',] }],
    address: [{ type: Input, args: ['address',] }],
    total: [{ type: Input, args: ['total',] }],
    canEdit: [{ type: Input, args: ['canEdit',] }],
    canAdd: [{ type: Input, args: ['canAdd',] }],
    seeAllUrl: [{ type: Input, args: ['seeAllUrl',] }],
    max: [{ type: Input, args: ['max',] }],
    allowInternationalAddresses: [{ type: Input, args: ['allowInternationalAddresses',] }],
    entityName: [{ type: Input, args: ['entityName',] }],
    showDelete: [{ type: Input, args: ['showDelete',] }],
    useMaxAsLimit: [{ type: Input, args: ['useMaxAsLimit',] }],
    onSave: [{ type: Output, args: ['onSave',] }],
    onDelete: [{ type: Output, args: ['onDelete',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonAddressesComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-addresses',
                template: `
        <div class="miles-card padded" *ngIf="!isEditing">
            <h4>{{ getComponentName() }}</h4>
            <ul *ngIf="addressContainerArray.length" class="list-group">
                <li *ngFor="let address of addressContainerArray" (click)="selectedAddress = address" class="list-group-item">
                    {{ getIndividualAddressTitle(address.Address) }}
                    <i
                        *ngIf="showIsPrimary && address.IsPrimary"
                        class="fa fa-fw fa-star pull-right"
                        [style.marginTop.px]="3"
                        title="Primary Address"
                    ></i>
                </li>
            </ul>
            <i *ngIf="!addressContainerArray.length">No {{ getComponentName() }}</i>
            <div [hidden]="hideAdd()" class="fab-wrap">
                <button type="button" class="btn btn-primary btn-fab-md btn-fab-center" (click)="addAddress()">
                    <span class="fa fa-plus"></span>
                </button>
            </div>
            <div class="pull-right max-of-total">
                <span *ngIf="showTotal()">{{ _max }} of {{ _total }}</span>
            </div>
            <div class="show-on-hover" *ngIf="showTotal()">
                <a (click)="seeAll()" class="btn btn-primary btn-flat see-all"
                    >see all
                    <span class="badge">{{ _total }}</span>
                </a>
            </div>
        </div>
        <div class="miles-form padded" *ngIf="isEditing">
            <h4>
                {{ selectedAddress.AddressId > 0 ? 'Edit ' + getComponentName() : 'Add ' + getComponentName() }}
            </h4>
            <form [formGroup]="addressForm" (ngSubmit)="save()">
                <mt-address
                    [addressContainer]="selectedAddress"
                    [parentForm]="addressForm"
                    [showIsPrimary]="showIsPrimary"
                    [allowInternationalAddresses]="_allowInternationalAddresses"
                ></mt-address>
                <button type="submit" class="btn btn-flat btn-success">Save</button>
                <button type="button" class="btn btn-flat btn-default" (click)="selectedAddress = null">Cancel</button>
                <button *ngIf="showDelete" type="button" class="btn btn-flat btn-danger pull-right" (mtConfirm)="delete()">Delete</button>
            </form>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { onSave: [{
            type: Output,
            args: ['onSave']
        }], onDelete: [{
            type: Output,
            args: ['onDelete']
        }], addressContainerArray: [{
            type: Input,
            args: ['addressContainerArray']
        }], address: [{
            type: Input,
            args: ['address']
        }], max: [{
            type: Input,
            args: ['max']
        }], useMaxAsLimit: [{
            type: Input,
            args: ['useMaxAsLimit']
        }], total: [{
            type: Input,
            args: ['total']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], canAdd: [{
            type: Input,
            args: ['canAdd']
        }], seeAllUrl: [{
            type: Input,
            args: ['seeAllUrl']
        }], allowInternationalAddresses: [{
            type: Input,
            args: ['allowInternationalAddresses']
        }], entityName: [{
            type: Input,
            args: ['entityName']
        }], showDelete: [{
            type: Input,
            args: ['showDelete']
        }], service: [{
            type: Input,
            args: ['service']
        }] }); })();

class AddressesEntityListConfig extends EntityListConfig {
    constructor(allowInternationalAddresses = false, disableSort) {
        const standardConfig = {
            columns: [
                new EntityListColumn({
                    accessors: ['Address', 'Address1'],
                    name: 'Address 1',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'Address2'],
                    name: 'Address 2',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'City'],
                    name: 'City',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'StateCode'],
                    name: 'State',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'Zip'],
                    name: 'Zip',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
            ],
        };
        const internationalConfig = {
            columns: [
                new EntityListColumn({
                    accessors: ['Address', 'Address1'],
                    name: 'Address 1',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'Address2'],
                    name: 'Address 2',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'City'],
                    name: 'City',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessorFunction: function (addressContainer) {
                        let address = addressContainer.Address;
                        let isInternational = address.CountryCode !== 'US';
                        return isInternational ? address.Province : address.StateCode;
                    },
                    name: 'State/Province',
                    sort: {
                        disableSort: disableSort,
                        sortProperty: 'Address.StateCode',
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'Zip'],
                    name: 'Zip',
                    sort: {
                        disableSort: disableSort,
                    },
                }),
                new EntityListColumn({
                    accessors: ['Address', 'Country', 'Name'],
                    name: 'Country',
                    sort: {
                        disableSort: disableSort,
                        sortProperty: 'Address.CountryCode',
                    },
                }),
            ],
        };
        super(allowInternationalAddresses ? internationalConfig : standardConfig);
    }
}

class CommonAddressesListComponent {
    constructor(injector) {
        this.injector = injector;
        this.searchControl = new FormControl();
        this.itemsPerPage = 12;
        this.currentPage = 1;
        this.canEdit = false;
        this._selectedAddress = null;
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
        this.config = injector.get(EntityComponentsAddressesModuleConfig);
        this._disableSort = this.config.disableSort;
        this.entityListConfig = new AddressesEntityListConfig(false, this._disableSort);
        this.order = this.entityListConfig.getDefaultSortProperty();
        this.orderDirection = this.entityListConfig.getDefaultSortDirection();
    }
    set disableSort(value) {
        this._disableSort = value;
    }
    get selectedAddress() {
        return this._selectedAddress;
    }
    set selectedAddress(value) {
        if (value === null) {
            this.addressForm = new FormGroup({});
        }
        this._selectedAddress = value;
    }
    ngOnInit() {
        var _a;
        this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => this.getAddresses());
        this.addressForm = new FormGroup({});
        const config = this.route.parent.snapshot.data;
        this.id = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        this.canEdit = this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]);
        const service = this.getServiceFromConfig(config);
        this.service = this.injector.get(service);
        this.entityName = (config && config.adressesEntityName) || null;
        this.allowInternationalAddresses = (_a = config === null || config === void 0 ? void 0 : config.allowInternationalAddresses) !== null && _a !== void 0 ? _a : false;
        if (this.allowInternationalAddresses) {
            this.entityListConfig = new AddressesEntityListConfig(true, this._disableSort);
        }
        this.getAddresses();
    }
    getServiceFromConfig(config) {
        var _a;
        let childRoute = this.route.snapshot;
        while (childRoute.firstChild) {
            childRoute = childRoute.firstChild;
        }
        const childConfig = childRoute.data;
        return (_a = childConfig === null || childConfig === void 0 ? void 0 : childConfig.service) !== null && _a !== void 0 ? _a : config === null || config === void 0 ? void 0 : config.service;
    }
    getAddresses() {
        const search = this.searchControl.value;
        const searchparamProperties = {
            order: this.order,
            orderDirection: this.orderDirection,
            query: (search === null || search === void 0 ? void 0 : search.length) > 0 ? search : '',
            skip: (this.currentPage - 1) * this.itemsPerPage,
            take: this.itemsPerPage,
        };
        const searchparams = new SearchParams(searchparamProperties);
        this.service.getAddresses(this.id, searchparams).subscribe((response) => {
            this.addresses = response.body;
            this.total = +response.headers.get('X-List-Count');
        });
    }
    columnSorted(event) {
        this.order = event.column.sort.sortProperty;
        this.orderDirection = event.column.sort.direction === SortDirection.Desc ? 'desc' : 'asc';
        this.getAddresses();
    }
    getComponentName() {
        if (this.entityName) {
            return this.entityName;
        }
        return 'Address';
    }
    clearSearch() {
        this.searchControl.setValue('');
    }
    addAddress() {
        this.selectedAddress = AddressContainer.getNew();
    }
    save() {
        if (this.addressForm.valid) {
            const address = Object.assign({}, this._selectedAddress);
            address.AddressId = this.addressForm.value.Id;
            address.Address = {
                Address1: this.addressForm.value.Address1,
                Address2: this.addressForm.value.Address2,
                City: this.addressForm.value.City,
                CountryCode: this.addressForm.value.CountryCode,
                Id: this.addressForm.value.Id,
                Province: this.addressForm.value.Province,
                StateCode: this.addressForm.value.StateCode,
                Zip: this.addressForm.value.Zip,
            };
            address.IsPrimary = this.addressForm.value.IsPrimary;
            this.service.saveAddress(this.id, address).subscribe((success) => {
                this.notificationsService.success('Address Saved Successfully');
                this.selectedAddress = null;
                this.getAddresses();
            }, (error) => this.notificationsService.error('Save Failed'));
        }
        else {
            this.notificationsService.error('Save Failed');
            markAllFormFieldsAsTouched(this.addressForm);
        }
    }
    cancel() {
        this.selectedAddress = null;
    }
    delete() {
        if (this.addressForm.value.Id) {
            this.deleteAddressById(this.addressForm.value.Id);
        }
    }
    deleteAddress(event) {
        this.deleteAddressById(event.entity.Address.Id);
    }
    deleteAddressById(addressId) {
        this.service.deleteAddress(this.id, addressId).subscribe((success) => {
            this.notificationsService.success('Address Deleted');
            this.selectedAddress = null;
            this.getAddresses();
        }, (error) => this.notificationsService.error('Delete Failed'));
    }
    selectAddress(event) {
        let address = event.entity;
        if (this.selectedAddress === address) {
            this.selectedAddress = null;
        }
        else {
            this.selectedAddress = address;
        }
    }
}
CommonAddressesListComponent.ɵfac = function CommonAddressesListComponent_Factory(t) { return new (t || CommonAddressesListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonAddressesListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonAddressesListComponent, selectors: [["app-common-addresses-list"]], inputs: { disableSort: "disableSort" }, decls: 5, vars: 2, consts: [[4, "ngIf"], ["class", "miles-form padded", 4, "ngIf"], [1, "input-group"], ["type", "text", "placeholder", "Search", 1, "form-control", 3, "formControl"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-nohover", "btn-flat", 3, "click"], [1, "fa"], ["aria-hidden", "true", 1, "fa", "fa-remove"], [3, "entities", "itemsPerPage", "total", "currentPage", "entityListConfig", "currentPageChange", "onPageChanged", "onItemSelected", "onItemDeleted", "onColumnSorted"], [1, "btn", "btn-default", 3, "routerLink"], ["class", "fab-wrap-b-r", 3, "click", 4, "ngIf"], [1, "fab-wrap-b-r", 3, "click"], [1, "btn", "btn-primary", "btn-fab-lg"], [1, "fa", "fa-plus"], [1, "miles-form", "padded"], [3, "formGroup", "ngSubmit"], [3, "addressContainer", "parentForm", "allowInternationalAddresses"], ["type", "submit", 1, "btn", "btn-flat", "btn-success"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], ["type", "button", "class", "btn btn-flat btn-danger pull-right", 3, "mtConfirm", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-danger", "pull-right", 3, "mtConfirm"]], template: function CommonAddressesListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonAddressesListComponent_div_1_Template, 32, 9, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵtemplate(3, CommonAddressesListComponent_div_3_Template, 18, 6, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.selectedAddress || !ctx.canEdit);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedAddress && ctx.canEdit);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlDirective, ɵngcc5.EntityListComponent, ɵngcc6.RouterLinkWithHref, ɵngcc2.ɵangular_packages_forms_forms_y, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.MtAddressComponent, ɵngcc4.MtConfirmDirective], encapsulation: 2 });
CommonAddressesListComponent.ctorParameters = () => [
    { type: Injector }
];
CommonAddressesListComponent.propDecorators = {
    disableSort: [{ type: Input, args: ['disableSort',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonAddressesListComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-addresses-list',
                template: `
        <div *ngIf="!selectedAddress || !canEdit">
            <div>
                <div class="input-group">
                    <input type="text" [formControl]="searchControl" class="form-control" placeholder="Search" />
                    <span class="input-group-btn">
                        <button type="button" (click)="clearSearch()" class="btn btn-default btn-nohover btn-flat">
                            <i class="fa"></i>
                            <i class="fa fa-remove" aria-hidden="true"></i>
                            <i class="fa"></i>
                        </button>
                    </span>
                </div>
                <br />
            </div>
            <entity-list
                [entities]="addresses"
                [itemsPerPage]="itemsPerPage"
                [total]="total"
                [(currentPage)]="currentPage"
                (onPageChanged)="getAddresses()"
                (onItemSelected)="selectAddress($event)"
                (onItemDeleted)="deleteAddress($event)"
                (onColumnSorted)="columnSorted($event)"
                [entityListConfig]="entityListConfig"
            >
            </entity-list>
            <a [routerLink]="['../']" class="btn btn-default">Back</a>
            <div *ngIf="canEdit" class="fab-wrap-b-r" (click)="addAddress()">
                <a class="btn btn-primary btn-fab-lg">
                    <span class="fa fa-plus"></span>
                </a>
            </div>
        </div>
        <div *ngIf="selectedAddress && canEdit" class="miles-form padded">
            <h4>
                {{ selectedAddress.AddressId > 0 ? 'Edit ' + getComponentName() : 'Add ' + getComponentName() }}
            </h4>
            <form [formGroup]="addressForm" (ngSubmit)="save()">
                <mt-address
                    [addressContainer]="selectedAddress"
                    [parentForm]="addressForm"
                    [allowInternationalAddresses]="allowInternationalAddresses"
                ></mt-address>
                <button type="submit" class="btn btn-flat btn-success">Save</button>
                <button type="button" class="btn btn-flat btn-default" (click)="cancel()">Cancel</button>
                <button *ngIf="selectedAddress.AddressId > 0" type="button" class="btn btn-flat btn-danger pull-right" (mtConfirm)="delete()">
                    Delete
                </button>
            </form>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { disableSort: [{
            type: Input,
            args: ['disableSort']
        }] }); })();

class EntityComponentsAddressesModule {
}
EntityComponentsAddressesModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntityComponentsAddressesModule });
EntityComponentsAddressesModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntityComponentsAddressesModule_Factory(t) { return new (t || EntityComponentsAddressesModule)(); }, imports: [[CommonModule, NgbModule, RouterModule, DynamicFormModule, MtAlertsModule, EntityListModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntityComponentsAddressesModule, { declarations: function () { return [CommonAddressesComponent, CommonAddressesListComponent]; }, imports: function () { return [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtAlertsModule, EntityListModule]; }, exports: function () { return [CommonAddressesComponent, CommonAddressesListComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsAddressesModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonAddressesComponent, CommonAddressesListComponent],
                exports: [CommonAddressesComponent, CommonAddressesListComponent],
                imports: [CommonModule, NgbModule, RouterModule, DynamicFormModule, MtAlertsModule, EntityListModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CommonAddressesComponent, CommonAddressesListComponent, EntityComponentsAddressesModule };

//# sourceMappingURL=mt-ng2-entity-components-addresses.js.map